<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户名称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户名称" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="病症" prop="illnessName">
                <a-input v-model="queryParam.illnessName" placeholder="请输入病症" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="患者类型" prop="patientType">
                <a-select v-model="queryParam.patientType" placeholder="请选择患者类型" allow-clear>
                  <a-select-option :value="1">儿童</a-select-option>
                  <a-select-option :value="2">成人</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="择医范围" prop="range">
                  <a-select v-model="queryParam.range" placeholder="请选择择医范围" allow-clear>
                    <a-select-option :value="1">市</a-select-option>
                    <a-select-option :value="2">省</a-select-option>
                    <a-select-option :value="3">全国</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="省/市" prop="cityProvinceName">
                  <a-input v-model="queryParam.cityProvinceName" placeholder="请输入省/市" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="患者姓名" prop="name">
                  <a-input v-model="queryParam.name" placeholder="请输入患者姓名" allow-clear @pressEnter="handleQuery"/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="性别" prop="sex">
                  <a-select v-model="queryParam.sex" placeholder="请选择性别" allow-clear>
                    <a-select-option :value="1">男</a-select-option>
                    <a-select-option :value="2">女</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否分配" prop="isAllot">
                  <a-select v-model="queryParam.isAllot" placeholder="请选择是否分配" allow-clear>
                    <a-select-option :value="0">未分配</a-select-option>
                    <a-select-option :value="1">已分配</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="支付状态" prop="status">
                  <a-select v-model="queryParam.status" placeholder="请选择支付状态" allow-clear>
                    <a-select-option :value="0">待支付</a-select-option>
                    <a-select-option :value="1">已支付</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>

            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:choose:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:choose:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:choose:remove']">-->
        <!--          <a-icon type="delete" />删除-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:choose:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="payTime" slot-scope="text, record">
          {{ parseTime(record.payTime) }}
        </span>
        <span slot="avatar" slot-scope="text, record">
          <img
            v-viewer
            v-if="record.avatar"
            :src="processImageUrl(record.avatar)"
            class="avatar"
            style="width: 100px;height: 100px; object-fit: cover; border-radius: 4px;"
            @error="handleImageError" />
          <a-icon v-else type="user" style="font-size: 80px; color: #ccc;" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">

          <a v-if="record.isAllot == 0" @click="openDoctor(record)" v-hasPermi="['user:choose:edit']">
            <a-icon type="edit" />分配
          </a>
          <a v-if="record.isAllot == 1" @click="openDoctor(record)" v-hasPermi="['user:choose:edit']">
            <a-icon type="edit" />重新分配
          </a>
          <!--          <a-divider v-if="record.isAllot == 0 && record.type == 3" type="vertical" v-hasPermi="['user:choose:query']" />-->
          <!--          <a @click="$refs.createForm.handleInfo(record)" v-hasPermi="['user:choose:query']">-->
          <!--            <a-icon type="search" />详情-->
          <!--          </a>-->
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <!-- 分配医生抽屉 -->
      <a-drawer
        title="分配医生"
        placement="right"
        :width="900"
        :visible="doctorVisible"
        :closable="true"
        @close="onClose"
        destroyOnClose
      >
        <!-- 择医条件提示 -->
        <div v-if="currentChoose" class="choose-condition-info">
          <a-alert type="info" show-icon>
            <template slot="message">
              <span class="condition-label">择医筛选条件：</span>
              <span v-if="currentChoose.illnessName" class="condition-item">
                <a-tag color="blue">病症：{{ currentChoose.illnessName }}</a-tag>
              </span>
              <span v-if="currentChoose.range" class="condition-item">
                <a-tag color="green">范围：{{ currentChoose.range === 1 ? '市' : currentChoose.range === 2 ? '省' : '全国' }}</a-tag>
              </span>
              <span v-if="currentChoose.cityProvinceName" class="condition-item">
                <a-tag color="orange">地区：{{ currentChoose.cityProvinceName }}</a-tag>
              </span>
              <span v-if="currentChoose.patientType" class="condition-item">
                <a-tag color="purple">患者类型：{{ currentChoose.patientType === 1 ? '儿童' : '成人' }}</a-tag>
              </span>
              <span class="condition-item">
                <a-tag color="red">需要医师数量：{{ currentChoose.doctorNum || 0 }}名</a-tag>
              </span>
            </template>
          </a-alert>
        </div>

        <!-- 患者详情信息 -->
        <div v-if="currentChoose" class="patient-detail-info">
          <a-card size="small" title="患者详情信息" :bordered="false">
            <a-row :gutter="16">
              <a-col :span="8">
                <div class="info-item">
                  <span class="info-label">手机号：</span>
                  <span class="info-value">{{ currentChoose.phone || '-' }}</span>
                </div>
              </a-col>
              <a-col :span="16">
                <div class="info-item">
                  <span class="info-label">病状描述：</span>
                  <span class="info-value">{{ currentChoose.illnessDesc || '-' }}</span>
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="16" style="margin-top: 12px;">
              <a-col :span="24">
                <div class="info-item">
                  <span class="info-label">检查报告图片：</span>
                  <div v-if="currentChoose.checkReport" class="report-images">
                    <img
                      v-for="(img, index) in parseImages(currentChoose.checkReport)"
                      :key="index"
                      :src="processImageUrl(img)"
                      class="report-image"
                      @click="previewImage(img)"
                    />
                  </div>
                  <span v-else class="info-value">-</span>
                </div>
              </a-col>
            </a-row>
          </a-card>
        </div>

        <!-- 医生筛选区域 -->
        <div class="doctor-filter-section">
          <a-form layout="inline">
            <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="医院名称">
                  <a-input
                    v-model="doctorParam.hospitalName"
                    placeholder="请输入医院名称"
                    allow-clear
                    @pressEnter="handleQuery2"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="科室名称">
                  <a-input
                    v-model="doctorParam.departName"
                    placeholder="请输入科室名称"
                    allow-clear
                    @pressEnter="handleQuery2"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="医师姓名">
                  <a-input
                    v-model="doctorParam.name"
                    placeholder="请输入医师姓名"
                    allow-clear
                    @pressEnter="handleQuery2"
                  />
                </a-form-item>
              </a-col>

              <template v-if="doctorAdvance">
                <a-col :md="8" :sm="24">
                  <a-form-item label="职称">
                    <a-input
                      v-model="doctorParam.professional"
                      placeholder="请输入职称"
                      allow-clear
                      @pressEnter="handleQuery2"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="擅长领域">
                    <a-input
                      v-model="doctorParam.strongPoint"
                      placeholder="请输入擅长领域"
                      allow-clear
                      @pressEnter="handleQuery2"
                    />
                  </a-form-item>
                </a-col>
                <a-col :md="8" :sm="24">
                  <a-form-item label="个人简介">
                    <a-input
                      v-model="doctorParam.content"
                      placeholder="请输入简介关键词"
                      allow-clear
                      @pressEnter="handleQuery2"
                    />
                  </a-form-item>
                </a-col>
              </template>

              <a-col :md="!doctorAdvance && 8 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="doctorAdvance && { float: 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" @click="handleQuery2"><a-icon type="search" />查询</a-button>
                  <a-button style="margin-left: 8px" @click="resetQuery2"><a-icon type="redo" />重置</a-button>
                  <a @click="toggleAdvanced2" style="margin-left: 8px">
                    {{ doctorAdvance ? '收起' : '展开' }}
                    <a-icon :type="doctorAdvance ? 'up' : 'down'"/>
                  </a>
                </span>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <!-- 选择提示 -->
        <div v-if="currentChoose" class="selection-tip">
          <span>已选 <span style="color: #1890ff; font-weight: bold;">{{ selectedRowKeys2.length }}</span> 位医师，需要 <span style="color: #1890ff; font-weight: bold;">{{ currentChoose.doctorNum || 0 }}</span> 位</span>
          <a-tag v-if="selectedRowKeys2.length > (currentChoose?.doctorNum || 0)" color="warning" style="margin-left: 8px;">已超出需要数量</a-tag>
        </div>

        <!-- 医生列表区域 -->
        <a-table
          :loading="doctorLoading"
          :size="tableSize"
          rowKey="id"
          :columns="doctorColumns"
          :data-source="doctorList"
          :row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange2, getCheckboxProps: getCheckboxProps }"
          :pagination="false"
          :bordered="tableBordered"
          :scroll="{ x: 850, y: 350 }"
        >
          <span slot="logo" slot-scope="text, record">
            <img v-viewer v-if="record.logo" :src="processImageUrl(record.logo)" style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px;" />
            <span v-else>-</span>
          </span>
          <span slot="hospitalName" slot-scope="text, record">
            <a-tooltip v-if="record.hospitalName" placement="topLeft">
              <template slot="title">
                {{ record.hospitalName }}（{{ record.departName || '-' }}）
              </template>
              <span style="max-width: 150px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ record.hospitalName }}（{{ record.departName || '-' }}）</span>
            </a-tooltip>
            <span v-else>-</span>
          </span>
          <span slot="name" slot-scope="text, record">
            {{ text }}
          </span>
          <span slot="sex" slot-scope="text, record">
            {{ text === 1 ? '男' : '女' }}
          </span>
          <span slot="professional" slot-scope="text, record">
            {{ text || '-' }}
          </span>
          <span slot="workYear" slot-scope="text, record">
            {{ text ? text + '年' : '-' }}
          </span>
          <span slot="strongPoint" slot-scope="text, record">
            <a-tooltip v-if="text" placement="topLeft">
              <template slot="title">
                {{ text }}
              </template>
              <span style="max-width: 100px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ text }}</span>
            </a-tooltip>
            <span v-else>-</span>
          </span>
          <span slot="content" slot-scope="text, record">
            <a-tooltip v-if="text" placement="topLeft">
              <template slot="title">
                {{ text }}
              </template>
              <span style="max-width: 100px; display: inline-block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ text }}</span>
            </a-tooltip>
            <span v-else>-</span>
          </span>
          <span slot="score" slot-scope="text, record">
            {{ text !== null && text !== undefined ? Number(text).toFixed(1) : '-' }}
          </span>
        </a-table>

        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="doctorParam.pageNum"
          :total="doctorTotal"
          :page-size="doctorParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange2"
          @change="changeSize2"
        />

        <!-- 底部操作区 -->
        <div class="drawer-footer">
          <a-button type="primary" :disabled="multiple2 || selectedRowKeys2.length > (currentChoose?.doctorNum || 0)" @click="submit" v-hasPermi="['user:choose:edit']">
            <a-icon type="check" />确认分配
          </a-button>
          <a-button style="margin-left: 8px" @click="onClose">
            取消
          </a-button>
        </div>
      </a-drawer>

    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageChoose, listChoose, delChoose, allotChoose, allotDetail, selectDoctorByChoose } from '@/api/user/choose'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { pageDoctor } from '@/api/doctor/doctor'
import { processImageUrl } from '@/utils/util'
export default {
  name: 'Choose',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      doctorList: [],
      selectedRowKeys: [],
      selectedRows: [],

      selectedRowKeys2: [],
      selectedRows2: [],
      // 高级搜索 展开/关闭
      advanced: false,
      doctorAdvance: false,
      // 非单个禁用
      single: true,
      doctorVisible: false,
      currentChoose: null,
      // 防抖函数
      debouncedGetDoctor: null,
      debouncedGetList: null,
      // 筛选条件展开
      filterExpand: [],
      // 非多个禁用
      multiple: true,
      multiple2: true,
      ids: [],
      doctorIds: [],
      loading: false,
      doctorLoading: false,
      total: 0,
      doctorTotal: 0,
      // 查询参数
      queryParam: {
        userId: null,
        type: 3,
        range: null,
        cityProvince: null,
        cityProvinceName: null,
        nickname: null,
        name: null,
        patientType: null,
        sex: null,
        doctorNum: null,
        price: null,
        score: null,
        illnessId: null,
        illnessName: null,
        status: null,
        payType: null,
        payTime: null,
        isAllot: null,
        pageNum: 1,
        pageSize: 10
      },
      // 查询参数
      doctorParam: {
        hospitalName: null,
        departName: null,
        name: null,
        professional: null,
        honor: null,
        strongPoint: null,
        content: null,
        pageNum: 1,
        pageSize: 10
      },
      doctorColumns: [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          width: 200,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'hospitalName' }
        },
        {
          title: '医师形象',
          dataIndex: 'logo',
          width: 100,
          ellipsis: true,
          scopedSlots: { customRender: 'logo' },
          align: 'center'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '性别',
          dataIndex: 'sex',
          width: 80,
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 1) {
              return '男'
            } else {
              return '女'
            }
          }
        },
        {
          title: '职称',
          dataIndex: 'professional',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工龄',
          dataIndex: 'workYear',
          width: 80,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '获得荣誉',
          dataIndex: 'honor',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '擅长领域',
          dataIndex: 'strongPoint',
          width: 200,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'strongPoint' }
        },
        {
          title: '个人简介',
          dataIndex: 'content',
          width: 200,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'content' }
        },
        {
          title: '华歧系数',
          dataIndex: 'score',
          width: 100,
          ellipsis: true,
          align: 'center'
        }
      ],
      columns: [
        {
          title: '用户名称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            return text === 1 ? 'ai择医' : text === 2 ? '自主择医' : '人工择医'
          }
        },
        {
          title: '择医范围',
          dataIndex: 'range',
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text === 1) {
              return '市'
            } else if (text === 2) {
              return '省'
            } else if (text === 3) {
              return '全国'
            }
          }
        },
        {
          title: '病症',
          dataIndex: 'illnessName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '省/市',
          dataIndex: 'cityProvinceName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '患者姓名',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '患者类型',
          dataIndex: 'patientType',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text === 1) {
              return '儿童'
            } else if (text === 2) {
              return '成人'
            }
          }
        },
        {
          title: '性别',
          dataIndex: 'sex',
          ellipsis: true,
          align: 'center',
          customRender: function (text) {
            if (text === 1) {
              return '男'
            } else if (text === 2) {
              return '女'
            }
          }
        },
        {
          title: '需要医师数量',
          dataIndex: 'doctorNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '医币数',
          dataIndex: 'price',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '积分数',
        //   dataIndex: 'score',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    // 创建防抖函数
    this.debouncedGetDoctor = this.debounce(this.getDoctor, 300)
    this.debouncedGetList = this.debounce(this.getList, 300)
  },
  beforeDestroy () {
    // 清理防抖函数
    this.debouncedGetDoctor = null
    this.debouncedGetList = null
  },
  computed: {
    /**
     * 是否有筛选条件
     */
    hasFilterConditions() {
      return !!(
        this.doctorParam.hospitalName ||
        this.doctorParam.departName ||
        this.doctorParam.name ||
        this.doctorParam.professional ||
        this.doctorParam.strongPoint ||
        this.doctorParam.content
      )
    }
  },
  watch: {
  },
  methods: {
    processImageUrl,
    /** 图片加载错误处理 */
    handleImageError (e) {
      e.target.style.display = 'none'
      e.target.nextElementSibling.style.display = 'inline-block'
    },
    /** 医生图片加载错误处理 */
    handleDoctorImageError (e) {
      e.target.style.display = 'none'
      e.target.nextElementSibling.style.display = 'inline-block'
    },
    /**
     * 解析检查报告图片字符串
     */
    parseImages(checkReport) {
      if (!checkReport) return []
      return checkReport.split(',').filter(img => img && img.trim())
    },
    /**
     * 预览图片
     */
    previewImage(url) {
      this.$viewerApi({
        images: [this.processImageUrl(url)],
        options: {
          toolbar: false,
          navbar: false,
          title: false
        }
      })
    },
    /**
     * 防抖工具函数
     */
    debounce(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    /** 查询择医记录列表 */
    getList () {
      this.loading = true
     pageChoose(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    submit() {
      // 验证是否选择了医生
      if (!this.selectedRowKeys2 || this.selectedRowKeys2.length === 0) {
        this.$message.warning('请至少选择一名医生')
        return
      }

      // 验证医生数量是否超过需求
      const needDoctorNum = this.currentChoose?.doctorNum || 0
      if (needDoctorNum > 0 && this.selectedRowKeys2.length > needDoctorNum) {
        this.$message.warning(`当前择医需求只需${needDoctorNum}名医生，已选择${this.selectedRowKeys2.length}名`)
        return
      }

      allotChoose({ chooseId: this.chooseId, doctorIds: this.doctorIds }).then(response => {
        if (response.success) {
          const actionText = this.currentChoose?.isAllot === 1 ? '重新分配' : '分配'
          this.$message.success(`${actionText}成功`)
          this.doctorVisible = false
          this.selectedRowKeys2 = []
          this.selectedRows2 = []
          this.doctorIds = []
          this.chooseId = null
          this.currentChoose = null
          this.getList()
        } else {
          this.$message.error(response.message)
        }
      }).catch(err => {
        console.error('分配失败', err)
        this.$message.error('分配失败，请稍后重试')
      })
    },

    onClose () {
      this.doctorVisible = false
      this.selectedRowKeys2 = []
      this.selectedRows2 = []
      this.chooseId = null
      this.doctorIds = []
      this.getList()
    },

    openDoctor(record) {
      this.doctorVisible = true
      this.chooseId = record.id
      this.currentChoose = record
      // 重置医生列表选择
      this.selectedRowKeys2 = []
      this.selectedRows2 = []
      this.doctorIds = []
      this.multiple2 = true

      // 重置医生搜索条件
      this.doctorParam = {
        hospitalName: null,
        departName: null,
        name: null,
        professional: null,
        honor: null,
        strongPoint: null,
        content: null,
        pageNum: 1,
        pageSize: 10
      }

      this.getDoctor()
      // 获取已分配的医生列表
      allotDetail({ chooseId: this.chooseId }).then(res => {
        if (res.success && res.data) {
          this.selectedRowKeys2 = res.data || []
          this.selectedRows2 = []
          this.doctorIds = this.selectedRowKeys2
          if (this.selectedRowKeys2.length > 0) {
            this.multiple2 = false
          }
        }
      }).catch(err => {
        console.error('获取分配详情失败', err)
      })
    },

    /**
     * 复选框属性控制
     */
    getCheckboxProps(record) {
      return {
        disabled: false
      }
    },

    /**
     * 获取筛选条件数量
     */
    getFilterCount() {
      let count = 0
      if (this.doctorParam.hospitalName) count++
      if (this.doctorParam.departName) count++
      if (this.doctorParam.name) count++
      if (this.doctorParam.professional) count++
      if (this.doctorParam.strongPoint) count++
      if (this.doctorParam.content) count++
      return count
    },

    getDoctor() {
      this.doctorLoading = true
      // 使用择医条件筛选医师列表
      const param = {
        id: this.chooseId, // 择医记录ID
        pageNum: this.doctorParam.pageNum,
        pageSize: this.doctorParam.pageSize,
        // 支持额外的筛选条件
        hospitalName: this.doctorParam.hospitalName,
        departName: this.doctorParam.departName,
        name: this.doctorParam.name,
        professional: this.doctorParam.professional,
        strongPoint: this.doctorParam.strongPoint
      }
      selectDoctorByChoose(param).then(response => {
        this.doctorList = response.data.records
        this.doctorTotal = response.data.total
        this.doctorLoading = false
      }).catch(err => {
        console.error('获取医师列表失败', err)
        this.doctorLoading = false
        // 如果新接口失败，降级使用原接口
        pageDoctor(this.doctorParam).then(response => {
          this.doctorList = response.data.records
          this.doctorTotal = response.data.total
          this.doctorLoading = false
        })
      })
    },
    handleQuery2 () {
      this.doctorParam.pageNum = 1
      this.getDoctor()
    },
    /** 重置按钮操作 */
    resetQuery2 () {
      this.doctorParam = {
        hospitalName: null,
        departName: null,
        name: null,
        professional: null,
        honor: null,
        strongPoint: null,
        content: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery2()
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: null,
        type: 3,
        range: null,
        cityProvince: null,
        cityProvinceName: null,
        nickname: null,
        name: null,
        patientType: null,
        sex: null,
        doctorNum: null,
        price: null,
        score: null,
        illnessId: null,
        illnessName: null,
        status: null,
        payType: null,
        payTime: null,
        isAllot: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    onShowSizeChange2 (current, pageSize) {
      this.doctorParam.pageSize = pageSize
      this.getDoctor()
    },
    changeSize2 (current, pageSize) {
      this.doctorParam.pageNum = current
      this.doctorParam.pageSize = pageSize
      this.getDoctor()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },

    onSelectChange2 (selectedRowKeys, selectedRows) {
      this.selectedRowKeys2 = selectedRowKeys
      this.selectedRows2 = selectedRows
      this.doctorIds = this.selectedRows2.map(item => item.id)
      this.multiple2 = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    toggleAdvanced2 () {
      this.doctorAdvance = !this.doctorAdvance
    },

    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delChoose(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('user/choose/export', {
            ...that.queryParam
          }, `择医记录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
/* 优化搜索表单布局 */
.table-page-search-wrapper {
  margin-bottom: 16px;
}

/* 优化操作按钮间距 */
.table-operations {
  margin-bottom: 16px;
}

.table-operations .ant-btn {
  margin-right: 8px;
}

/* 优化表格间距 */
.ant-table-pagination {
  margin-top: 16px;
}

/* 响应式优化 */
@media (max-width: 768px) {
  .table-page-search-wrapper {
    /deep/ .ant-col {
      width: 100% !important;
    }
  }
}

/* ========== 分配医生抽屉样式 ========== */

/* 择医条件提示 */
.choose-condition-info {
  margin-bottom: 16px;
}

.choose-condition-info .condition-label {
  font-weight: 500;
  margin-right: 8px;
}

.choose-condition-info .condition-item {
  margin-right: 8px;
}

/* 患者详情信息 */
.patient-detail-info {
  margin-bottom: 16px;
}

.patient-detail-info .info-item {
  margin-bottom: 8px;
}

.patient-detail-info .info-label {
  font-weight: 500;
  color: #333;
  margin-right: 8px;
}

.patient-detail-info .info-value {
  color: #666;
}

.patient-detail-info .report-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.patient-detail-info .report-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  transition: all 0.3s;
}

.patient-detail-info .report-image:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 医生筛选区域 */
.doctor-filter-section {
  background: #fafafa;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
}

/* 选择提示 */
.selection-tip {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 14px;
}

/* 底部操作区 */
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #e8e8e8;
  text-align: right;
}
</style>
